import React from "react";
import { Button, Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import { useTranslation } from 'react-i18next';


interface ToolsCardProps {
    title: string
    description: string
    onChange: () => void
}

const ToolsCard = (props: ToolsCardProps) => {
    const { t } = useTranslation(['oneRoster']);

    return (
        <Card>
            <CardHeader tag="h5" style={{ flexDirection: 'row' }}>
                {props.title}
            </CardHeader>
            <CardBody>
                {props.description}
            </CardBody>
            <CardFooter>
                <Button onClick={props.onChange}>{t('tools.get')}</Button>
            </CardFooter>
        </Card>
    )
}

export default ToolsCard;
